module.exports = __webpack_public_path__ + "static/fieldset-0a734d90d059e011728b2e43195bfdd0.png";